import { JSX, useCallback, useMemo, useState } from 'react'

import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'
import { IWidget } from 'core-components/sitebuilder/models/IWidget'
import { IWidgetsListDetail, WidgetsListDetail } from 'core-components/sitebuilder/settings/Detail'

import { IWidgetTypeValue, WidgetTypes } from './constants/widgetTypes'
import { createWidget } from './helpers/createWidget'
import { IRenderCustomSettingsParams } from './models/IRenderCustomContent'

interface IProps {
  getWidgetAfterSaving: (widget: IWidget) => void
  renderCustomSettingsWidget?: (data: IRenderCustomSettingsParams) => JSX.Element | null
}

export const NewWidgetsButtons = (props: IProps) => {
  const [widget, setWidget] = useState<IWidget>()
  const [titleDetail, setTitle] = useState<string>('')

  const widgetTypes = useMemo(() => {
    return Object.keys(WidgetTypes) as IWidgetTypeValue['type'][]
  }, [])

  const onCreateHandler = useCallback((widgetTypesData: IWidgetTypeValue) => {
    const widget = createWidget()
    setWidget({ ...widget, type: widgetTypesData.type, isNew: true })
    setTitle(widgetTypesData.createNewWidgetHeaderText)
  }, [])

  return (
    <>
      {widgetTypes.map((type) => {
        const item = WidgetTypes[type] as IWidgetTypeValue
        return (
          <Button key={type} onClick={() => onCreateHandler(item)}>
            {item.createNewWidgetButtonText}
          </Button>
        )
      })}
      {widget ? (
        <ModalDialog<IWidgetsListDetail>
          onClose={() => setWidget(undefined)}
          size={'md'}
          show={!!widget}
          content={WidgetsListDetail}
          title={titleDetail}
          contentProps={{
            widget,
            renderCustomSettingsWidget: props.renderCustomSettingsWidget,
            onClose: () => setWidget(undefined),
            getWidgetAfterSaving: (newWidget: IWidget) => {
              setWidget(undefined)
              props.getWidgetAfterSaving(newWidget)
            },
          }}
        />
      ) : null}
    </>
  )
}
